'use client';

import React from 'react';
import { useAnalytics } from '@/contexts/AnalyticsContext';
import { LMS_EVENTS } from '@/lib/analytics';

interface CourseFiltersProps {
  categories: { id: string; name: string }[];
  activeCategory: string;
  setActiveCategory: (c: string) => void;
  activeSortBy: string;
  setActiveSortBy: (s: string) => void;
}

const sortOptions = [
  { id: 'popular', label: 'Most Popular' },
  // { id: 'newest', label: 'Newest' },
  // { id: 'price-low', label: 'Price: Low to High' },
  // { id: 'price-high', label: 'Price: High to Low' },
  { id: 'rating', label: 'Top Rated' },
];

export default function CourseFilters({
  categories,
  activeCategory,
  setActiveCategory,
  activeSortBy,
  setActiveSortBy,
}: CourseFiltersProps) {
  const { track } = useAnalytics();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
      {/* Category pills — horizontal scroll on mobile */}
      <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-1 -mx-1 px-1">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => {
              setActiveCategory(cat.id);
              track(LMS_EVENTS.COURSE_FILTER_APPLIED, {
                filterType: 'category',
                value: cat.id,
                label: cat.name,
              });
            }}
            className={`flex-shrink-0 px-3.5 py-1.5 rounded-full text-xs font-medium transition-all duration-150 ${
              activeCategory === cat.id
                ? 'bg-brand-primary text-white shadow-sm'
                : 'bg-white text-brand-text-muted border border-brand-border hover:border-brand-border-dark hover:text-brand-text-dark'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* Sort dropdown */}
      <div className="flex-shrink-0 min-w-[160px] relative">
        <select
          value={activeSortBy}
          onChange={(e) => {
            setActiveSortBy(e.target.value);
            track(LMS_EVENTS.COURSE_FILTER_APPLIED, { filterType: 'sort', value: e.target.value });
          }}
          className="w-full appearance-none bg-white border border-brand-border hover:border-brand-border-dark text-brand-text text-sm font-semibold rounded-xl px-4 py-2.5 pr-10 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-primary/20 cursor-pointer"
        >
          {sortOptions.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.label}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3.5 text-brand-text-muted">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </div>
  );
}
